<template>
  <td v-html="date"></td>
</template>

<script lang="babel">
import { defaultNullHtml } from '@/js/defaultNullHtml';

export default {
    props: ['content'],
    computed: {
      date() {
        const date = new Date(this.content);

        return !isNaN(date) ?
          date.toLocaleDateString([], { day: '2-digit', month: '2-digit', year: 'numeric' }) :
          defaultNullHtml();
      },
    }
};
</script>
